import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const LinkedinIconMessage = ({
  color = colors.black,
  className,
  onClick,
  style,
}: IProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox={'0 0 16 16'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      {...style}
    >
      <path
        d="M0 12C0 14.2056 1.7944 16 4 16H8.12792C7.5 15.5 7.57712 15 7.523 14.6667H4C2.5296 14.6667 1.33333 13.4704 1.33333 12V4C1.33333 2.5296 2.5296 1.33333 4 1.33333H12C13.4704 1.33333 14.6667 2.5296 14.6667 4V8.65745C15.3009 8.65745 16 9.25657 16 9.25657V4C16 1.7944 14.2056 0 12 0H4C1.7944 0 0 1.7944 0 4V12Z"
        fill={color}
      />
      <path
        d="M5.03353 6.37307V11.1C5.03353 11.4681 4.735 11.7667 4.36686 11.7667C3.99873 11.7667 3.7002 11.4681 3.7002 11.1V6.37307C3.7002 6.00493 3.99873 5.7064 4.36686 5.7064C4.735 5.7064 5.03353 6.00493 5.03353 6.37307ZM4.36686 3.5C3.99873 3.5 3.7002 3.79853 3.7002 4.16667V4.3C3.7002 4.66813 3.99873 4.96667 4.36686 4.96667C4.735 4.96667 5.03353 4.66813 5.03353 4.3V4.16667C5.03353 3.79853 4.735 3.5 4.36686 3.5ZM9.90273 5.79573C9.23633 5.6648 8.41366 5.8388 7.697 6.40293C7.6802 6.04973 7.39086 5.76773 7.03353 5.76773C6.6654 5.76773 6.36686 6.06627 6.36686 6.4344V11.1C6.36686 11.4681 6.6654 11.7667 7.03353 11.7667C7.40166 11.7667 7.7002 11.4681 7.7002 11.1V8.61293C7.70793 8.5976 7.71766 8.58387 7.72433 8.5676C8.1818 7.44867 9.03699 6.98427 9.64566 7.10387C10.1041 7.19387 10.3669 7.6092 10.3669 8.2432V8.1C10.3669 8.46813 10.6654 8.76667 11.0335 8.76667C11.4017 8.76667 11.7002 8.46813 11.7002 8.1V8.24333C11.7002 6.97107 10.9946 6.01027 9.90273 5.79573Z"
        fill={color}
      />
      <path
        d="M14.7334 11.1216C14.7332 10.9009 14.5547 10.7223 14.334 10.7222L10 10.7212C9.7791 10.7212 9.59963 10.9007 9.59961 11.1216V14.3228C9.59986 14.5742 9.80414 14.7778 10.0557 14.7778H14.2783C14.5297 14.7777 14.7331 14.5741 14.7334 14.3228V11.1216ZM15.9336 14.3228C15.9333 15.2369 15.1925 15.9779 14.2783 15.978H10.0557C9.1414 15.978 8.40064 15.237 8.40039 14.3228V11.1216C8.40041 10.2379 9.11636 9.52197 10 9.52197H14.334C15.2174 9.52215 15.9334 10.2382 15.9336 11.1216V14.3228Z"
        fill={color}
      />
      <path
        d="M8.4043 10.9974C8.40438 10.1704 9.07434 9.50045 9.90137 9.50037H14.4346C15.2619 9.50037 15.9326 10.1711 15.9326 10.9984C15.9325 11.4946 15.6863 11.9591 15.2744 12.2377L14.9385 11.7406L14.6016 11.2445L14.6025 11.2435L14.6562 11.1957C14.7042 11.1421 14.7323 11.0724 14.7324 10.9984C14.7324 10.8335 14.5988 10.6996 14.4346 10.6996H9.90137C9.73708 10.6997 9.6036 10.8331 9.60352 10.9974C9.60352 11.0963 9.65259 11.1891 9.73438 11.2445L11.3203 12.3187L11.418 12.3802C11.9155 12.6649 12.5356 12.644 13.0156 12.3187L14.6016 11.2445L15.2744 12.2377L13.6895 13.3119C12.8283 13.8956 11.7149 13.9329 10.8223 13.4222L10.6465 13.3119L9.06152 12.2377C8.64999 11.9588 8.4043 11.494 8.4043 10.9974Z"
        fill={color}
      />
    </svg>
  );
};

export default LinkedinIconMessage;
